import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardGroup,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Row,
} from "reactstrap";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import Modal from "react-responsive-modal";
import axios from "axios";

import LoginMutation from "../../../mutations/Login.js";
import ChangePassword from "../../../mutations/ChangePassword";

import logo from "../../../assets/img/brand/Logo.png";

class Login extends Component {
  state = {
    email: "",
    password: "",
    cpassword: "",
    irecoveryCode: "",
    alert: false,
    onForgot: false,
    onRecovery: false,
    onChange: false,
  };

  sendRecovery() {
    const recoveryCode = Math.floor(1000 + Math.random() * 9000);
    console.log("recoveryCode:", recoveryCode);
    const body = {
      email: this.state.email.toLowerCase().trim(),
      subject: "SETENS - Codigo Contraseña",
      text: `Su código para cambiar la contraseña es: ${recoveryCode}`,
      from: process.env.REACT_APP_SESACCESSKEY,
      sesAccessKey: process.env.REACT_APP_SESACCESSKEY,
      sesSecretKey: process.env.REACT_APP_SESSECRETKEY,
    };
    axios
      .post("https://borilabs.herokuapp.com/sendEmail", { body })
      .then((response) => {
        this.setState({ onForgot: false, onRecovery: true, recoveryCode });
      })
      .catch((e) => {
        this.setState({
          alert: (
            <SweetAlert
              danger
              title="Uh Oh!"
              onConfirm={() => this.setState({ alert: null })}
              confirmBtnText="OK"
              closeOnClickOutside={true}
            >
              Hubo un error enviando el código de seguridad. Intente de nuevo. Si sigue ocurriendo
              el error, contacte a administración.
            </SweetAlert>
          ),
        });
      });
  }

  checkRecovery() {
    if (parseInt(this.state.irecoveryCode) === this.state.recoveryCode) {
      this.setState({ onRecovery: false, onChange: true });
    } else {
      this.setState({
        alert: (
          <SweetAlert
            danger
            title="Uh Oh!"
            onConfirm={() => this.setState({ alert: null })}
            confirmBtnText="OK"
            closeOnClickOutside={true}
          >
            El código parece estar incorrecto. Por favor intente nuevamente.
          </SweetAlert>
        ),
      });
    }
  }

  render() {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
    }
    return (
      <div className="app flex-row align-items-center login-background">
        {this.state.alert}
        <Container>
          <Row className="justify-content-center">
            <Col md="10" lg="5" xl="5">
              <center>
                <img src={logo} width="500px" alt="SERA Logo" />
              </center>
              <CardGroup>
                <Card className="p-4 login-boxshadow">
                  <CardBody>
                    <Form onSubmit={(e) => this._login(e)}>
                      <InputGroup className="mb-3">
                        <Input
                          type="email"
                          placeholder="EMAIL"
                          autoComplete="email"
                          className="login-input"
                          onChange={(e) => this.setState({ email: e.target.value })}
                        />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <Input
                          type="password"
                          placeholder="PASSWORD"
                          autoComplete="current-password"
                          className="login-input"
                          onChange={(e) => this.setState({ password: e.target.value })}
                        />
                      </InputGroup>
                      <Row className="text-center">
                        <Col lg="12">
                          <Button
                            type="submit"
                            className="login-btn"
                            onClick={(e) => this._login(e)}
                          >
                            LOGIN
                          </Button>
                        </Col>
                        <Col lg="12">
                          <p
                            className="forgot-button"
                            onClick={() => this.setState({ onForgot: true })}
                          >
                            ¿Olvidó la contraseña?
                          </p>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>

        <Modal
          open={this.state.onForgot}
          onClose={() => this.setState({ onForgot: false })}
          className="pin-modal"
        >
          <Card className="top-space">
            <CardHeader className="text-center">
              <h5> Olvidó Contraseña </h5>
            </CardHeader>
            <CardBody className="text-center">
              <Row>
                <h5>Enviaremos un código de seguridad a su email.</h5>
                <FormGroup className="w-100 d-flex flex-row">
                  <Input
                    type="text"
                    className="formControlFix"
                    placeholder="email"
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                  />
                </FormGroup>
              </Row>
            </CardBody>

            <CardFooter className="space-between">
              <Button color="primary" onClick={() => this.sendRecovery()}>
                Enviar Código
              </Button>
              <Button color="primary" onClick={() => this.setState({ onForgot: false })}>
                Cancel
              </Button>
            </CardFooter>
          </Card>
        </Modal>

        <Modal
          open={this.state.onRecovery}
          onClose={() => this.setState({ onRecovery: false })}
          className="pin-modal"
        >
          <Card className="top-space">
            <CardHeader className="text-center">
              <h5> Código de Seguridad </h5>
            </CardHeader>
            <CardBody className="text-center">
              <Row>
                <h5>Verifique su email para un código de seguridad.</h5>
                <FormGroup className="w-100 d-flex flex-row">
                  <Input
                    type="number"
                    className="formControlFix"
                    placeholder="Recovery Code"
                    value={this.state.irecoveryCode}
                    onChange={(e) => this.setState({ irecoveryCode: e.target.value })}
                  />
                </FormGroup>
              </Row>
            </CardBody>

            <CardFooter className="space-between">
              <Button color="primary" onClick={() => this.checkRecovery()}>
                Someter
              </Button>
              <Button color="primary" onClick={() => this.setState({ onRecovery: false })}>
                Cancelar
              </Button>
            </CardFooter>
          </Card>
        </Modal>

        <Modal
          open={this.state.onChange}
          onClose={() => this.setState({ onChange: false })}
          className="pin-modal"
        >
          <Card className="top-space">
            <CardHeader className="text-center">
              <h5> Contraseña </h5>
            </CardHeader>
            <CardBody className="text-center">
              <Row>
                <FormGroup className="w-100 d-flex flex-row">
                  <Input
                    type="password"
                    className="formControlFix"
                    placeholder="contraseña"
                    value={this.state.password}
                    onChange={(e) => this.setState({ password: e.target.value })}
                  />
                </FormGroup>
                <FormGroup className="w-100 d-flex flex-row">
                  <Input
                    type="password"
                    className="formControlFix"
                    placeholder="confirma contraseña"
                    value={this.state.cpassword}
                    onChange={(e) => this.setState({ cpassword: e.target.value })}
                  />
                </FormGroup>
              </Row>
            </CardBody>

            <CardFooter className="space-between">
              <Button color="primary" onClick={() => this._changePassword()}>
                Someter
              </Button>
              <Button color="primary" onClick={() => this.setState({ onChange: false })}>
                Cancelar
              </Button>
            </CardFooter>
          </Card>
        </Modal>
      </div>
    );
  }

  _login = async (e) => {
    e.preventDefault();
    let errorMessage = "";
    let graphQLMessage = "";
    let { loginMutation } = this.props;

    let variables = {
      email: this.state.email,
      password: this.state.password,
    };

    try {
      let mutationResponse = await loginMutation({ variables });
      if (mutationResponse.data) {
        if (mutationResponse.data.login.user.active === true) {
          const user = mutationResponse.data.login.user;
          const role = user.role;
          localStorage.setItem("token", mutationResponse.data.login.token);
          localStorage.setItem("fname", user.fname);
          localStorage.setItem("lname", user.lname);
          localStorage.setItem("email", user.email);
          localStorage.setItem("userId", user.id);
          localStorage.setItem("role", role);
          if (role === "COORDINATOR") {
            this.props.history.replace(
              user.schoolsAdmin[0] ? "/school/" + user.schoolsAdmin[0]?.id : "/dashboard"
            );
          } else if (role === "TEACHER") {
            this.props.history.replace(
              user.schools[0] ? "/school/" + user.schools[0].id : "/dashboard"
            );
          } else if (role === "STUDENT") {
            this.props.history.replace("/student/" + user.id);
          } else if (role === "PARENT") {
            if (user.child) {
              this.props.history.replace("/student/" + user.child.id);
            } else {
              alert(
                "Perdone los inconvenientes, pero el sistema no parece tener ningún estudiante adjunto a esta cuenta. Por favor contacte a su coordinador para que lo asista."
              );
            }
          } else {
            this.props.history.replace("/dashboard");
          }
        } else {
          this.setState({
            alert: (
              <SweetAlert
                danger
                title="Uh Oh!"
                onConfirm={() => {
                  this.setState({ alert: null });
                }}
                closeOnClickOutside={true}
              >
                It seems like this user is not active.
              </SweetAlert>
            ),
          });
        }
      } else {
        console.log("Something went wrong with login!");
      }
    } catch (e) {
      console.log("error", e.message);
      for (let i = 0; i < 15; i++) {
        graphQLMessage = graphQLMessage + e.message.charAt(i);
      }
      errorMessage = e.message.replace(graphQLMessage, "");

      if (errorMessage === "resetPassword") {
        this.sendRecovery();
        this.setState({
          alert: (
            <SweetAlert
              warning
              title="Uh Oh!"
              onConfirm={() => {
                this.setState({ alert: null, onRecovery: true });
              }}
              closeOnClickOutside={true}
            >
              El sistema requiere que haga un cambio de contraseña. Enviamos un código de seguridad
              a su email para verificar en el próximo paso.
            </SweetAlert>
          ),
        });
      } else {
        this.setState({
          alert: (
            <SweetAlert
              warning
              title="Uh Oh!"
              onConfirm={() => {
                this.setState({ alert: null });
              }}
              closeOnClickOutside={true}
            >
              {errorMessage}
            </SweetAlert>
          ),
        });
      }
    }
  };

  _changePassword = async () => {
    let { changePassword } = this.props;

    if (this.state.password === this.state.cpassword) {
      const variables = {
        email: this.state.email,
        password: this.state.password,
      };
      try {
        let mutationResponse = await changePassword({ variables });
        if (mutationResponse.data) {
          this.setState({
            alert: (
              <SweetAlert
                success
                title="Listo!"
                onConfirm={() => this.setState({ alert: null, onChange: false })}
                confirmBtnText="OK"
                closeOnClickOutside={true}
              >
                Se cambió la contraseña exitosamente.
              </SweetAlert>
            ),
          });
        } else {
          this.setState({
            alert: (
              <SweetAlert
                warning
                title="Uh Oh!"
                onConfirm={() => this.setState({ alert: null })}
                confirmBtnText="OK"
                closeOnClickOutside={true}
              >
                Hubo un error cambiando su contraseña. Por favor intente de nuevo.
              </SweetAlert>
            ),
          });
        }
      } catch (e) {
        this.setState({
          alert: (
            <SweetAlert
              warning
              title="Uh Oh!"
              onConfirm={() => this.setState({ alert: null })}
              confirmBtnText="OK"
              closeOnClickOutside={true}
            >
              Hubo un error cambiando su contraseña. Por favor intente de nuevo.
            </SweetAlert>
          ),
        });
      }
    } else {
      this.setState({
        alert: (
          <SweetAlert
            warning
            title="Uh Oh!"
            onConfirm={() => this.setState({ alert: null })}
            confirmBtnText="OK"
            closeOnClickOutside={true}
          >
            Las contraseñas no concuerdan. Por favor intente de nuevo.
          </SweetAlert>
        ),
      });
    }
  };
}

export default compose(
  graphql(LoginMutation, { name: "loginMutation" }),
  graphql(ChangePassword, { name: "changePassword" })
)(Login);
